/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomPatientInsuranceForm/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BillingCenter from './BillingCenter/index'
import Carrier from './Carrier/index'
import Employers from './Employers/index'
import GroupNumber from './GroupNumber/index'
import LastVerified from './LastVerified/index'
import Name from './Name/index'
import OrthodonticCoverage from './OrthodonticCoverage/index'
import PlanNotes from './PlanNotes/index'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomPatientInsuranceForm({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm",
  hideLastVerified
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="DataVaxiomPatientInsuranceForm.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Carrier
  viewPath={`${viewPath}/Carrier`}
/>
<GroupNumber
  viewPath={`${viewPath}/GroupNumber`}
/>
</div>
<div
  data-testid="DataVaxiomPatientInsuranceForm.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<BillingCenter
  viewPath={`${viewPath}/BillingCenter`}
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={dtSpaceM}
 theme="light"
/>
<Employers
  viewPath={`${viewPath}/Employers`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<OrthodonticCoverage
  viewPath={`${viewPath}/OrthodonticCoverage`}
/>
<PlanNotes
  viewPath={`${viewPath}/PlanNotes`}
/>
<LastVerified
  viewPath={`${viewPath}/LastVerified`}
 hideLastVerified={hideLastVerified}
/>
{children}
</React.Fragment>)
}